"use client"

import cn from "classnames"

import { HubspotForm } from "~/components/primitives/HubspotForm"
import { Modal } from "~/components/primitives/Modal/Modal"
import { type ModalId } from "~/contexts/ModalContext"

import s from "./ContactModal.module.scss"

type ContactModalProps = {
  id: ModalId
  ariaLabel: string
  title: string
  description: string
  portalId: string
  formId: string
  className?: string
}

export const ContactModal = ({
  id,
  ariaLabel,
  title,
  description,
  portalId,
  formId,
  className,
}: ContactModalProps) => {
  return (
    <Modal id={id} aria-label={ariaLabel}>
      <div className={cn(s.content, className)}>
        <div>
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        <div>
          <HubspotForm portalId={portalId} formId={formId} />
        </div>
      </div>
    </Modal>
  )
}
